<template>
  <ScrollLocker :locked="scrollLocked">
    <Component v-if="!loading" :is="appLayout" />
  </ScrollLocker>
</template>

<script>
import { Action, State } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import ScrollLocker from '@/components/ScrollLocker'
import { AVAILABLE_LAYOUTS } from '@/router'
import DefaultApp from './views/Root/DefaultApp'
import LandingApp from './views/Root/LandingApp'
import WithoutForceLoginApp from './views/Root/WithoutForceLoginApp'

@Component({
  components: {
    ScrollLocker,
    DefaultApp,
    LandingApp,
    WithoutForceLoginApp
  }
})
class App extends Vue {
  @State(({ ui }) => ui.scrollLocked) scrollLocked
  @Action('getButtonData') getButtonData
  @Action('getPageContent') getPageContent
  @Action('getCardDesigns') getCardDesigns
  loading = true
  get appLayout () {
    if (!this.$route.meta.layout) {
      return DefaultApp
    } else if (this.$route.meta.layout === AVAILABLE_LAYOUTS.LANDING) {
      return LandingApp
    } else if (this.$route.meta.layout === AVAILABLE_LAYOUTS.WITHOUT_FORCE_LOGIN) {
      return WithoutForceLoginApp
    }
    return DefaultApp
  }
  created () {
    this.getData()
  }
  async getData () {
    await this.getButtonData()
    await this.getCardDesigns()
    await this.getPageContent(window.location.pathname)
    this.loading = false
  }
}

export default App
</script>

<style lang="scss">
@import "@/common/assets/scss/common/common.scss";

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  position: relative;

  &_content {
    flex-grow: 1;
    overflow: hidden;
    padding-top: $menu_height;
    @include media_tablet {
      padding-top: $menu_height_tablet;
    }
  }
}

.page-transition {
  &-enter-active, &-leave-active {
    transition: all .3s ease-in-out;
  }

  &-enter, &-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
}

.app-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
</style>
